var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_vm._v("Мега статистика, графики и пр.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }